import { z } from 'zod';

/**
 * In-app "Send feedback" submission (docs/prd/12-support-feedback.md).
 * `platform` is a free-form string (not a strict enum) since it must accommodate
 * web/desktop/mobile clients and mobile's own ios/android split without this
 * shared schema needing to enumerate every current and future client target.
 */
export const feedbackSchema = z.object({
  category: z.enum(['bug', 'feature', 'general']),
  message: z.string().min(1).max(4000),
  appVersion: z.string().min(1).max(40).optional(),
  platform: z.string().min(1).max(40).optional(),
});
export type FeedbackInput = z.infer<typeof feedbackSchema>;
